<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import { userClientData } from '../../stores';
	import type { Url } from 'KWS';

	const dispatch = createEventDispatcher();

	export let toRemove = false;
	export let url: Url;

	let bannersDisplayed = false;

	function dispatchControls() {
		dispatch('controls');
	}
</script>

<tr class="divider">
	<td colspan="7" />
</tr>
<tbody>
	{#if toRemove}
		<tr class="grayed">
			<td class="controls">
				<div on:click={dispatchControls}>
					<svg style="width:24px;height:24px" viewBox="0 0 24 24">
						<path
							fill={$userClientData.webData.primaryColor}
							d="M17,13H13V17H11V13H7V11H11V7H13V11H17M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
						/>
					</svg>
				</div>
			</td>
			<td><strong>{url.score.toFixed(2)}</strong></td>
			<td style="min-width: 300px; max-width: 475px; word-break: break-all;">{url.url}</td>
			<td
				><strong>
					{#if typeof url.seconds !== 'undefined'}
						{url.seconds}s
					{/if}
				</strong></td
			>
			<td>
				<strong>
					{#if typeof url.CPM !== 'undefined'}
						{url.CPM}&nbsp;czk
					{/if}
				</strong>
			</td>
			<td>
				<strong>
					{#if typeof url.CTR !== 'undefined'}
						{url.CTR}%
					{/if}
				</strong>
			</td>
			<td class="opening">
				<span on:click={() => (bannersDisplayed = !bannersDisplayed)}
					>{@html bannersDisplayed ? '&#x25B2;' : '&#x25BC;'}</span
				>
			</td>
		</tr>
	{:else}
		<tr>
			<td class="controls">
				<div on:click={dispatchControls}>
					<svg style="width:24px;height:24px" viewBox="0 0 24 24">
						<path
							fill={$userClientData.webData.primaryColor}
							d="M17,13H7V11H17M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
						/>
					</svg>
				</div>
			</td>
			<td><strong>{url.score.toFixed(2)}</strong></td>
			<td style="min-width: 300px; max-width: 475px; word-break: break-all;">{url.url}</td>
			<td
				><strong>
					{#if typeof url.seconds !== 'undefined'}
						{url.seconds}s
					{/if}
				</strong></td
			>
			<td>
				<strong>
					{#if typeof url.CPM !== 'undefined'}
						{url.CPM}&nbsp;czk
					{/if}
				</strong>
			</td>
			<td>
				<strong>
					{#if typeof url.CTR !== 'undefined'}
						{url.CTR}%
					{/if}
				</strong>
			</td>
			<td class="opening">
				<span on:click={() => (bannersDisplayed = !bannersDisplayed)}
					>{@html bannersDisplayed ? '&#x25B2;' : '&#x25BC;'}</span
				>
			</td>
		</tr>
	{/if}
	{#if bannersDisplayed}
		{#each Object.keys(url.banners) as banner}
			<tr>
				<td />
				<td />
				<td style="min-width: 300px; max-width: 475px; word-break: break-all;"
					>{banner.split('_').pop()}</td
				>
				<td>
					{#if typeof url.banners[banner]['seconds_' + banner.split('_').pop()] !== 'undefined'}
						{url.banners[banner]['seconds_' + banner.split('_').pop()]}s
					{/if}
				</td>
				<td>
					{#if typeof url.banners[banner]['CPM_' + banner.split('_').pop()] !== 'undefined'}
						{url.banners[banner]['CPM_' + banner.split('_').pop()]} czk
					{/if}
				</td>
				<td>
					{#if typeof url.banners[banner]['CTR_' + banner.split('_').pop()] !== 'undefined'}
						{url.banners[banner]['CTR_' + banner.split('_').pop()]}%
					{/if}
				</td>
				<td />
			</tr>
		{/each}
	{/if}
</tbody>

<style>
	.grayed {
		opacity: 0.5;
		filter: saturate(0%);
	}

	tbody {
		font-size: 14px;
	}

	td.opening span {
		cursor: pointer;
	}
</style>
